
import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class ShowMenus extends Vue {
    @Prop({ default: () => () => [] }) items: any[];
}
